import React from "react";
import { getIn } from "formik";
import { Number } from "../../utils/Number";
import { TextField } from "@material-ui/core";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import AutoCompleteStates from "../FormComponents/AutoCompleteStates";

const yourInsuranceInfo = [
  {
    label: "Name of Carrier",
    name: "autoInsurance.nameOfCarrier",
    type: "text",
  },
  {
    label: "Policyholder Name",
    name: "autoInsurance.policyHolderName",
    type: "text",
  },
  {
    label: "Policy Number",
    name: "autoInsurance.policyNo",
    type: "text",
  },
  {
    label: "Claim Number",
    name: "autoInsurance.claimNo",
    type: "text",
  },

  {
    label: "Adjuster",
    name: "autoInsurance.adjuster",
    type: "text",
  },

  {
    label: "Address",
    name: "autoInsurance.addressLine1",
    type: "text",
  },

  { label: "City", name: "autoInsurance.city", type: "text" },
  { label: "State", name: "autoInsurance.state", type: "autoComplete" },
  { label: "ZIP Code", name: "autoInsurance.zipCode", type: "number" },
  {
    label: "Phone",
    name: "autoInsurance.phone",
    type: "phone",
  },
];

const Attorney = ({ values, touched, error, handleChange, errors, setFieldValue }) => {
  return (
    <div className="row">
      <div className="form-group col-lg-12">
        <h5> Your Auto Insurance </h5>
      </div>
      <div className="col-12">
        <div className="row">
          {yourInsuranceInfo.map(({ label, name, type, required = false }, ind) => {
            if (type === "text") {
              return (
                <div className="form-group col-md-6 col-lg-4 col-12">
                  <TextField
                    label={label}
                    name={name}
                    onChange={handleChange}
                    value={values[name]}
                    aria-label="text-field"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required={required}
                    inputProps={{
                      maxLength:
                        name === "autoInsurance.nameOfCarrier" ||
                        name === "autoInsurance.addressLine1" ||
                        name === "autoInsurance.policyHolderName" ||
                        name === "autoInsurance.adjuster"
                          ? 50
                          : 35,
                    }}
                    // margin="dense"
                  ></TextField>
                </div>
              );
            } else if (type === "number" || type === "phone") {
              return (
                <div className="form-group col-md-6 col-lg-4 col-12">
                  <TextField
                    label={label}
                    name={name}
                    onChange={handleChange}
                    value={values[name]}
                    aria-label="text-field"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ maxLength: type === "number" ? 5 : undefined }}
                    required={required}
                    InputProps={{
                      inputComponent: type === "phone" ? TextMaskCustom : Number,
                    }}
                    // margin="dense"
                  ></TextField>
                </div>
              );
            } else if (type === "autoComplete") {
              return (
                <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                  <AutoCompleteStates
                    label={label}
                    name={name}
                    onChange={(e, value) => {
                      if (value) {
                        setFieldValue(`${name}`, value.code);
                      } else {
                        setFieldValue(`${name}`, "");
                      }
                    }}
                    value={values[name]}
                    aria-label="auto-complete"
                    fullWidth
                    error={Boolean(getIn(touched, name) && getIn(errors, name))}
                    helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    required={required}
                  />
                </div>
              );
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default Attorney;
